/**
 * Locales rendered right-to-left. Used to set `dir="rtl"` on `<html>`
 * and to flip CSS via logical properties (margin-inline-*, padding-inline-*, etc.).
 */
export const RTL_LOCALES = ['ar'];
export function isRTL(locale) {
    return RTL_LOCALES.includes(locale);
}
export function getDir(locale) {
    return isRTL(locale) ? 'rtl' : 'ltr';
}
//# sourceMappingURL=rtl.js.map